import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CardLinkingStore, CardLinkingState } from './card-linking.store';

@Injectable({ providedIn: 'root' })
export class CardLinkingQuery extends QueryEntity<CardLinkingState> {
  constructor(protected store: CardLinkingStore) {
    super(store);
  }
 
}
